module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-star-88428409b677ded2dfd47308cb07a3c8.svg";